import {Box, Container, Grid, makeStyles, Theme, Typography} from "@material-ui/core";
import Image from "next/image";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: 100,
  },
  title: {
    fontSize: 32,
    fontWeight: 700,
    color: '#303940',
    [theme.breakpoints.up(960)]: {
      fontSize: 48,
    },
  },
  description: {
    fontSize: 16,
    fontWeight: 400,
    color: '#6E7C87',
    marginBottom: 32,
    [theme.breakpoints.up(960)]: {
      fontSize: 24,
    },
  }
}));

export const ServicePartners = ({title, list, description}) => {
  const classes = useStyles();

  return (
    <Container className={classes.container} maxWidth={false} fixed>
        <Typography align={'center'} className={classes.title}>{title}</Typography>
        <Typography align={'center'} className={classes.description}>{description}</Typography>
        <Grid container justifyContent={'center'} spacing={2}>
          {list.map((el, index) => (
            <Grid key={index} md={3} sm={6} xs={12} item>
              <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <Image width={285} height={72} src={el.image} />
              </Box>

              <Typography align={'center'}>{el.text}</Typography>
            </Grid>
          ))}
        </Grid>

    </Container>
  )
}

export default ServicePartners
